module.exports = __webpack_public_path__ + "static/bluearth-logo-445f46813e34bfd41df3b10cbede0b3f.png";